export default 'M10.78 13.22V0A12.03 12.03 0 1 0 24 13.22zm2.5-2.5H24A12.04 12.04 0 0 0 13.29 0z';